export default class CopyCode {
  constructor() {
    this.selector = '[data-copycode="true"]'
    this.init()
  }

  init() {

    // Wrap copiable element
    $(this.selector).wrap('<div class="copycode-wrapper d-flex align-items-center"></div>')

    // Create copyCode button & add it to DOM
    let btnCopyCode = $('<button type="button" class="btn btn-default btn-copyCode" style="order: 1"><i class="fas fa-copy"></i></button>')
    $(btnCopyCode).insertBefore(this.selector)

    // Add event listener to copyCode button
    $(document).on('click', 'button.btn-copyCode', function() {
      
      // Create textarea and fill it with wanted code
      var tempTextarea = $("<textarea>")
      
      let htmlCode_clone = $(this).next('[data-copycode="true"]').clone(true).removeAttr('data-copycode')[0].outerHTML
      tempTextarea.val(htmlCode_clone)
      
      $("body").append(tempTextarea)
      tempTextarea.select()
      document.execCommand("copy")
      tempTextarea.remove()

      // Add class to animate copied element
      Toastr.options = {
        positionClass: "toast-bottom-right"
      }
      Toastr.info('copied!')
      $(this).addClass('clicked');

      setTimeout(() => {
        $(this).removeClass('clicked');
      }, 1000)
    })
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new CopyCode()
})